export class TransportTypes {
  static Auto = 'auto'
  static Bus = 'bus'
  static Truck = 'truck'
  static Pedestrian = 'pedestrian'
  static Bike = 'bike'
  static Motorbike = 'motorbike'
}
